import React, { useRef, useState, useEffect } from 'react';
import * as cls from './case-study.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';
import { Link } from 'react-router-dom';
import { Button } from '../../../ui/components/button';
import { ButtonBuyNow } from '../../../ui/components/button-buy-now';

export const CaseStudy = () => {
  const sectionRef = useRef(null);
  const [animatedItems, setAnimatedItems] = useState(new Set());
  const [imageAnimated, setImageAnimated] = useState(false);
  const [bottomButtonAnimated, setBottomButtonAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const contentItems = sectionRef.current?.querySelectorAll(
            `.${cls.wrapper} > div:first-child > *`,
          );
          if (contentItems) {
            contentItems.forEach((item, index) => {
              setTimeout(() => {
                setAnimatedItems((prev) => new Set(prev).add(index));
              }, index * 300);
            });
          }

          setTimeout(() => {
            setImageAnimated(true);
          }, 600);

          setTimeout(() => {
            setBottomButtonAnimated(true);
          }, 900);
        }
      },
      {
        threshold: 0.4,
        rootMargin: '-50px 0px',
      },
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <div ref={sectionRef}>
      <div className={cls.wrapper}>
        <div>
          <Typography
            tag="h2"
            className={animatedItems.has(0) ? cls.animated : cls.hiddenLeft}
          >
            How Voltaware
            <br />
            Helps You Save
          </Typography>
          <Typography
            className={animatedItems.has(1) ? cls.animated : cls.hiddenLeft}
          >
            This case study describes a real-use application of the voltware
            smart electricity usage monitor that helped one of our clients cut
            her energy by £38 per month.
          </Typography>
          <Link
            to={ROUTES_PATHS.CASE_STUDIES}
            className={animatedItems.has(2) ? cls.animated : cls.hiddenLeft}
          >
            <Button size="sm" variant="green-transparent">
              Read Full Story
            </Button>
          </Link>
        </div>
        <div>
          <img
            src={`${IMG_PATH}/home/case-study-voltaware-helps-you-save.png`}
            alt="voltaware helps you save"
            className={imageAnimated ? cls.animatedImage : cls.hiddenImage}
          />
        </div>
      </div>

      <div
        className={
          bottomButtonAnimated
            ? cls.animatedBottomButton
            : cls.hiddenBottomButton
        }
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <ButtonBuyNow size="sm" />
      </div>
    </div>
  );
};
